/**
 * List of possible results for a Device Check-in Request
 */
export enum DeviceCheckinResultCode {
    CheckinSuccessfull = 0,
    CheckinTimeout = 1,
    Failed = 2
}

/**
 * SignalR Service Event for a Device Check-in result received
 */
export interface DeviceCheckinCompleted {
    deviceId: string;
    result: DeviceCheckinResultCode;
    checkinTime: Date;
}
